import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { partitionOptionConst, partitionOptionForwardLinkMap, sapHanaPartitionOptions } from '../consts/metadata-consts';

export const sapHanaTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sapHana.datasetType,
    displayName: stringResources.SapHana_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.sapHana.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-SapHANA'
    },
    isFirstClass: true,
    category: ['Database'],
    notSupportPhysicalType: true,
    splitTablePath: true,
    supportCreatedAsV2: true,
    supportParallelRead: true,
    copySourceControls: [
        {
            type: 'radio-switch',
            label: stringResources.ModelName_Partition_Option,
            defaultValue: partitionOptionConst.none,
            description: '<a target="_blank" href="' + partitionOptionForwardLinkMap[adfModelTypeMap.sapHana.copySourceType] + '">' + stringResources.LearnMore + '</a>',
            escapeDescription: false,
            options: sapHanaPartitionOptions,
            bind: 'partitionOption',
            isParameterizable: true,
            cases: [
                {
                    caseValue: partitionOptionConst.physicalPartitionsOfTable,
                    children: []
                },
                {
                    caseValue: partitionOptionConst.sapHanaDynamicRange,
                    children: [
                        {
                            type: 'parameterizable',
                            child: {
                                type: 'columns-selection',
                                bind: 'partitionColumnName',
                                label: stringResources.ModelName_Partition_ColumnName,
                                multiple: false,
                                includeCopySourceProperties: true,
                                excludeSourceProperties: ['partitionOption', 'partitionSettings']
                            },
                            dynamicContentTextClass: 'input-spaced'
                        }
                    ]
                }
            ]
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'packetSize',
                label: `${stringResources.ModelName_SapHanaSourcePacketSize}`,
                description: stringResources.SapHanaSourcePacketSize_Description,
                min: 1024,
                max: 2097151,
                validators: [
                    {
                        type: 'number',
                        min: 1024,
                        max: 2097151,
                        errorMessage: stringResources.SapHanaSourcePacketSize_ErrorMessage
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copyJob: {
        multipleQuery: true,
        sourcePartition: {
            supportSourcePartition: true
        }
    }
};
